export default class SubsidenceConsultantModel {
  public id: string
  public description: string
  public phone: string
  public email: string
}
